
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "EvidenceForHpEradication",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/EvidenceForHpEradication.vue